import { render, staticRenderFns } from "./non-profits.vue?vue&type=template&id=5b009570&scoped=true&"
import script from "./non-profits.vue?vue&type=script&lang=js&"
export * from "./non-profits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b009570",
  null
  
)

export default component.exports